// src/components/toast/ToastContainer.jsx
import { createPortal } from "react-dom";
import { useToast } from "./toast-context";
import { ToastItem } from "./ToastItem";

const posClasses = {
  "top-center":    "top-4 left-1/2 -translate-x-1/2",
  "top-right":     "top-4 right-4",
  "bottom-right":  "bottom-4 right-4",
  "bottom-center": "bottom-4 left-1/2 -translate-x-1/2",
  "bottom-left":   "bottom-4 left-4",
  "top-left":      "top-4 left-4",
};

export function ToastContainer() {
  const { toasts, position } = useToast();
  const node = (
    <div
      className={`fixed z-[99999] pointer-events-none ${posClasses[position]} w-[calc(100vw-1rem)] max-w-lg`}
    >
      <div className="space-y-2">
        {toasts.map((t) => (
          <ToastItem key={t.id} toast={t} />
        ))}
      </div>
    </div>
  );
  return createPortal(node, document.body);
}
